import { render, staticRenderFns } from "./RouteSection.vue?vue&type=template&id=231e1677&scoped=true&"
import script from "./RouteSection.vue?vue&type=script&lang=js&"
export * from "./RouteSection.vue?vue&type=script&lang=js&"
import style0 from "./RouteSection.vue?vue&type=style&index=0&id=231e1677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e1677",
  null
  
)

export default component.exports